// extracted by mini-css-extract-plugin
export default {"notificationsWraper":"Notifications_notificationsWraper__dptte","notification":"Notifications_notification__czg2H"};